module.exports = __webpack_public_path__ + "static/media/icon-marker-darkvoilet.dffd7141.svg";